module.exports = __webpack_public_path__ + "img/SuccessTurtle1.7ef1e12a.gif";